export default __webpack_public_path__ + "static/cruises_banner-afd479579b1a78d1cbc545212ab98ec8.png";